import Vue from 'vue'
import Vuex from 'vuex'

import feathers from '@/feathers/'
import { errorMessages } from '@/i18n/'

import distance from 'turf-distance'

import debounce from 'lodash.debounce'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    uri: feathers.io.io.uri,
    feathers: feathers,
    posInterval: null,
    loading: true,
    fetching: false,
    auth: {
      user: null,
      token: null,
      geolocation: {
        position: {
          lat: 44.4472043,
          lng: 26.0917751
        }
      }
    },
    snacks: {
      messages: [],
      visible: false
    },
    notifications: [],
    app: {
      light: (new Date().getHours() > 7 && new Date().getHours() < 21),
      clipped: true,
      fixed: true,
      drawer: true,
      mini: false,
      menuItems: [
        { icon: 'home', title: 'Acasa', link: '/' },
        { icon: 'vpn_key', title: 'Login', link: '/login', auth: false },
        { icon: 'dashboard', title: 'Panou de control', link: '/dashboard', auth: true, admin: true }
      ]
    },
    admin: {
      users: {
        data: [],
        search: '',
        page: 1,
        totalPages: 1,
        sort: {
          username: 1
        }
      },
      requests: {
        data: [],
        page: 1,
        totalPages: 1,
        sort: {
          createdAt: -1
        }
      }
    },
    addresses: {
      mine: {
        data: [],
        search: '',
        page: 1,
        totalPages: 1,
        sort: {
          nrcrt: 1
        },
        done: 0,
        google: 0,
        images: 0
      },
      all: {
        data: [],
        search: '',
        page: 1,
        totalPages: 1,
        sort: {
          nrcrt: 1
        },
        access: 0,
        done: 0,
        google: 0,
        images: 0
      },
      loading: false
    },
    photos: {

    },

    archives: {
      data: [],
      page: 1,
      totalPages: 1,
      sort: {
        createdAt: -1
      }
    },

    addresses4map: [],
    myaddresses4map: [],
    users4map: [],
    messages: {},
    pdfmessages: {},

    services: {
      users: feathers.service('users'),
      addresses: feathers.service('addresses'),
      photos: feathers.service('photos'),
      pdfs: feathers.service('pdfs'),
      requests: feathers.service('requests'),
      archives: feathers.service('downloads'),
      xlsx: feathers.service('xlsx'),
      histories: feathers.service('histories'),
      messages: feathers.service('messages'),
      thumbgenerator: feathers.service('thumbgenerator')
    }
  },
  getters: {
    uri: state => state.uri,
    snacksVisible: state => state.snacks.visible,
    snacksMessages: state => state.snacks.messages,
    appLight: state => state.app.light,
    appFixed: state => state.app.fixed,
    appDrawer: state => state.app.drawer,
    appMini: state => state.app.mini,
    appClipped: state => state.app.clipped,
    appMenuItems: state => state.app.menuItems,
    getUser: state => state.auth.user,
    getLocation: state => state.auth.geolocation.position,
    getLoading: state => state.loading,
    getFetching: state => state.fetching,
    getNotifications: state => state.notifications,

    getAllUsers: state => state.admin.users,
    getUsersPage: state => state.admin.users.page,
    getUsersSearch: state => state.admin.users.search,

    getAllRequests: state => state.admin.requests,
    getRequestsPage: state => state.admin.requests.page,

    getAllMyAddresses: state => state.addresses.mine,
    getMyAddressesPage: state => state.addresses.mine.page,
    getMyAddressesSearch: state => state.addresses.mine.search,

    getAllAddresses: state => state.addresses.all,
    getAllAddressesPage: state => state.addresses.all.page,
    getAllAddressesSearch: state => state.addresses.all.search,

    getAddresses4Map: state => state.addresses4map,
    getMyAddresses4Map: state => state.myaddresses4map,
    getUsers4Map: state => state.users4map,

    getArchives: state => state.archives,
    getArchivesPage: state => state.archives.page,

    addressLoading: state => state.addresses.loading,

    myAddDone: state => state.addresses.mine.done,
    myAddGoogle: state => state.addresses.mine.google,
    myAddImages: state => state.addresses.mine.images,

    addDone: state => state.addresses.all.done,
    addGoogle: state => state.addresses.all.google,
    addAccess: state => state.addresses.all.access,
    addImages: state => state.addresses.all.images,

    messages: state => state.messages,
    pdfmessages: state => state.pdfmessages
  },
  mutations: {
    setPosInterval (state, data) {
      if (state.posInterval) {
        clearInterval(state.posInterval)
      }
      state.posInterval = data
    },
    setLoading (state, data) {
      state.loading = data
    },
    setFetching (state, data) {
      state.fetching = data
    },
    setAuth (state, data) {
      state.auth.token = data.token
      state.auth.user = data.user
      state.auth.error = null
      state.loading = false
    },
    setGeolocationPosition (state, position) {
      let {coords: {latitude: lat, longitude: lng}} = position
      state.auth.geolocation.position = {lat: lat, lng: lng}
    },
    setSnack (state, data) {
      let copy = JSON.parse(JSON.stringify(data.error))
      copy.meta = data.meta || null
      copy.message = (copy.meta && copy.meta.error && copy.code) ? errorMessages[copy.code] : copy.message
      if (copy.message) {
        state.snacks.messages.push(copy)
        state.snacks.visible = true
      } else {
        // silent fail
      }
    },
    toggleSnacks (state, value) {
      state.snacks.visible = value
    },
    removeSnack (state) {
      state.snacks.messages.splice(0, 1)
    },
    toggleLight (state) {
      state.app.light = !state.app.light
    },
    closeDrawer (state) {
      state.app.drawer = false
    },
    openDrawer (state) {
      state.app.drawer = true
    },
    toggleMini (state) {
      state.app.mini = !state.app.mini
    },
    clearMessages (state) {
      state.snacks.messages = []
      state.snacks.visible = false
    },

    fillUsers (state, data) {
      state.admin.users.data = data
    },
    clearUsers (state) {
      state.admin.users.data = []
    },
    setUsersPage (state, page) {
      state.admin.users.page = page
    },
    setUsersSort (state, sort) {
      state.admin.users.sort = sort
    },
    setUsersSearch (state, search) {
      state.admin.users.search = search
    },

    fillMyAddresses (state, data) {
      state.addresses.mine.data = data
    },
    clearMyAddresses (state) {
      state.addresses.mine.data = []
    },
    setMyAddressesPage (state, page) {
      state.addresses.mine.page = page
    },
    setMyAddressesSort (state, sort) {
      state.addresses.mine.sort = sort
    },
    setMyAddressesSearch (state, search) {
      state.addresses.mine.search = search
    },

    fillAddresses (state, data) {
      state.addresses.all.data = data
    },
    clearAddresses (state) {
      state.addresses.all.data = []
    },
    setAddressesPage (state, page) {
      state.addresses.all.page = page
    },
    setAddressesSort (state, sort) {
      state.addresses.all.sort = sort
    },
    setAddressesSearch (state, search) {
      state.addresses.all.search = search
    },

    fillRequests (state, data) {
      state.admin.requests.data = data
    },
    setRequestsPage (state, page) {
      state.admin.requests.page = page
    },
    setRequestsSort (state, sort) {
      state.admin.requests.sort = sort
    },

    fillAddresses4Map (state, data) {
      state.addresses4map = data
    },
    fillMyAddresses4Map (state, data) {
      state.myaddresses4map = data
    },
    fillUsers4Map (state, data) {
      state.users4map = data
    },

    fillArchives (state, data) {
      state.archives.data = data
    },
    setArchivesPage (state, page) {
      state.archives.page = page
    },
    setArchivesSort (state, sort) {
      state.archives.sort = sort
    },
    addressLoading (state, value) {
      state.addresses.loading = value
    },
    toggleAddressesAccess (state, value) {
      state.addresses.all.access = value
    },
    toggleAddressesDone (state, value) {
      state.addresses.all.done = value
    },
    toggleAddressesGoogle (state, value) {
      state.addresses.all.google = value
    },
    toggleAddressesImages (state, value) {
      state.addresses.all.images = value
    },
    toggleMyAddressesDone (state, value) {
      state.addresses.mine.done = value
    },
    toggleMyAddressesGoogle (state, value) {
      state.addresses.mine.google = value
    },
    toggleMyAddressesImages (state, value) {
      state.addresses.mine.images = value
    },
    setMessage (state, payload) {
      if (!state.messages[payload._id]) {
        Vue.set(state.messages, payload._id, [payload.message])
      } else {
        if (state.messages[payload._id] > 100) {
          Vue.set(state.messages, payload._id, [payload.message])
        } else {
          state.messages[payload._id].push(payload.message)
        }
      }
    },
    setPdfMessage (state, payload) {
      if (!state.pdfmessages[payload._id]) {
        Vue.set(state.pdfmessages, payload._id, [payload.message])
      } else {
        if (state.pdfmessages[payload._id] > 100) {
          Vue.set(state.pdfmessages, payload._id, [payload.message])
        } else {
          state.pdfmessages[payload._id].push(payload.message)
        }
      }
    },
    deleteMessages (state, id) {
      if (state.messages[id]) {
        Vue.set(state.messages, id, [])
      }
    },
    deletePdfMessages (state, id) {
      if (state.pdfmessages[id]) {
        Vue.set(state.pdfmessages, id, [])
      }
    },
    refreshAddress (state, payload) {
      if (payload.type === 'mine') {
        const index = state.addresses.mine.data.data.findIndex(add => add._id === payload.item._id)
        if (index > -1) {
          Vue.set(state.addresses.mine.data.data, index, payload.item)
        }
      } else {
        const index = state.addresses.all.data.data.findIndex(add => add._id === payload.item._id)
        if (index > -1) {
          Vue.set(state.addresses.all.data.data, index, payload.item)
        }
      }
    }
  },
  actions: {
    login ({commit, dispatch}, data) {
      commit('setLoading', true)
      return dispatch('logout').then(res => {
        return feathers.authenticate({
          strategy: 'local',
          email: data.email,
          password: data.password
        })
        .then(response => {
          return grabAuthData(response, commit, dispatch)
        })
        .catch(error => {
          let meta = { error: true, success: false, info: false, warning: false }
          commit('setSnack', { error, meta })
          commit('setLoading', false)
        })
      })
    },
    logout ({commit}) {
      commit('setLoading', true)
      commit('setPosInterval', null)
      feathers.logout()
        .then(response => {
          commit('setAuth', {token: null, user: null})
          commit('clearUsers')
          commit('setLoading', false)
          commit('setSnack', {
            error: {
              message: 'Sesiunea de lucru a fost inchisa. Sunteti in modul anonim.'
            },
            meta: {
              error: false,
              success: true,
              info: false,
              warning: false
            }
          })
        })
        .catch(error => {
          let meta = { error: true, success: false, info: false, warning: false }
          commit('setSnack', { error, meta })
          commit('setLoading', false)
        })
    },
    attemptAuth ({commit, dispatch, state}) {
      feathers.passport.getJWT()
        .then(jwt => {
          if (jwt) {
            return state.feathers.authenticate({strategy: 'jwt', accessToken: jwt})
          }
          Promise.resolve(null)
        })
        .then(response => {
          if (response) {
            return grabAuthData(response, commit, dispatch)
          } else {
            commit('setLoading', false)
          }
          return Promise.resolve(null)
        })
        .catch(error => {
          let meta = { error: true, success: false, info: false, warning: false }
          commit('setSnack', { error, meta })
          commit('setLoading', false)
        })
    },
    toggleAdmin ({dispatch, commit, state}, data) {
      state.services.users.patch(data._id, {admin: data.admin, roles: data.admin ? ['admin'] : ['user']})
        .then(res => {
          dispatch('fetchUsers')
          commit('setSnack', {
            error: {
              message: `Operatiune reusita. Utilizatorul ${res.username} a fost ${res.admin ? 'promovat' : 'retrogradat'}.`
            },
            meta: {
              error: false,
              success: true,
              info: false,
              warning: false
            }
          })
        })
        .catch(error => {
          let meta = { error: true, success: false, info: false, warning: false }
          commit('setSnack', { error, meta })
        })
    },
    checkEmail ({state}, email) {
      return state.services.users.find({query: {email: email}})
    },

    deleteAllPhotos ({dispatch}, photoIDs) {
      photoIDs.forEach(id => {
        dispatch('deletePhoto', id)
      })
    },
    deleteAllPdfs ({dispatch}, pdfIDs) {
      pdfIDs.forEach(id => {
        dispatch('deletePdf', id)
      })
    },
    generateThumbs ({state, commit}, addressID) {
      state.services.thumbgenerator
        .create({id: addressID})
        .catch(error => {
          let meta = { error: true, success: false, info: false, warning: false }
          commit('setSnack', { error, meta })
        })
    },

    setEventWatchers ({dispatch, commit, state}) {
      state.services.users.on('created', user => {
        if (state.auth.user.admin) {
          dispatch('fetchUsers')
          dispatch('fetchUsers4Map')
        }
      })
      state.services.users.on('updated', user => {
        if (state.auth.user.admin) {
          dispatch('fetchUsers')
          dispatch('fetchUsers4Map')
        }
      })
      state.services.users.on('patched', user => {
        if (state.auth.user.admin) {
          dispatch('fetchUsers')
          dispatch('fetchUsers4Map')
          // console.log('users patched event')
        }
      })
      state.services.users.on('removed', user => {
        if (state.auth.user.admin) {
          dispatch('fetchUsers')
          dispatch('fetchUsers4Map')
        }
      })

      state.services.addresses.on('created', debounce(address => {
        dispatch('fetchMyAddresses')
        dispatch('fetchAddresses')
        dispatch('fetchMyAddresses4Map')
        dispatch('fetchAddresses4Map')
      }, 1000, { 'maxWait': 1000 }))
      state.services.addresses.on('updated', debounce(address => {
        dispatch('fetchMyAddresses')
        dispatch('fetchAddresses')
        dispatch('fetchMyAddresses4Map')
        dispatch('fetchAddresses4Map')
      }, 1000, { 'maxWait': 1000 }))
      state.services.addresses.on('patched', debounce(address => {
        dispatch('fetchMyAddresses')
        dispatch('fetchAddresses')
        dispatch('fetchMyAddresses4Map')
        dispatch('fetchAddresses4Map')
      }, 1000, { 'maxWait': 1000 }))
      state.services.addresses.on('removed', debounce(address => {
        dispatch('fetchMyAddresses')
        dispatch('fetchAddresses')
        dispatch('fetchMyAddresses4Map')
        dispatch('fetchAddresses4Map')
      }, 1000, { 'maxWait': 1000 }))

      state.services.requests.on('created', address => {
        if (state.auth.user.admin) {
          dispatch('fetchRequests')
        }
      })
      state.services.requests.on('updated', address => {
        if (state.auth.user.admin) {
          dispatch('fetchRequests')
        }
      })
      state.services.requests.on('patched', address => {
        if (state.auth.user.admin) {
          dispatch('fetchRequests')
        }
      })
      state.services.requests.on('removed', address => {
        if (state.auth.user.admin) {
          dispatch('fetchRequests')
        }
      })

      state.services.archives.on('created', address => {
        if (state.auth.user.admin) {
          dispatch('fetchArchives')
        }
      })
      state.services.archives.on('updated', address => {
        if (state.auth.user.admin) {
          dispatch('fetchArchives')
        }
      })
      state.services.archives.on('patched', address => {
        if (state.auth.user.admin) {
          dispatch('fetchArchives')
        }
      })
      state.services.archives.on('removed', address => {
        if (state.auth.user.admin) {
          dispatch('fetchArchives')
        }
      })

      state.services.messages.on('photo_saved', event => {
        if (event.user === state.auth.user._id) {
          commit('setMessage', {
            _id: event._id,
            message: {
              label: `Poza ${event.count} a fost salvata`,
              type: 'success'
            }
          })
        }
      })
      state.services.messages.on('photo_error', event => {
        if (event.user === state.auth.user._id) {
          commit('setMessage', {
            _id: event._id,
            message: {
              label: `Poza ${event.count} nu a putut fi salvata...`,
              type: 'error'
            }
          })
        }
      })
      state.services.messages.on('photo_count', event => {
        if (event.user === state.auth.user._id) {
          commit('setMessage', {
            _id: event._id,
            message: {
              label: `Se salveaza ${event.count} poze`,
              type: 'info'
            }
          })
        }
      })
      state.services.messages.on('photo_now', event => {
        if (event.user === state.auth.user._id) {
          commit('setMessage', {
            _id: event._id,
            message: {
              label: `Se salveaza poza ${event.count}!`,
              type: 'info'
            }
          })
        }
      })
      state.services.messages.on('photo_thumb_error', event => {
        if (event.user === state.auth.user._id) {
          commit('setMessage', {
            _id: event._id,
            message: {
              label: `Eroare la thumbnail pt poza ${event.count}...`,
              type: 'error'
            }
          })
        }
      })

      state.services.messages.on('pdf_saved', event => {
        if (event.user === state.auth.user._id) {
          commit('setPdfMessage', {
            _id: event._id,
            message: {
              label: `PDF-ul ${event.count} a fost salvat`,
              type: 'success'
            }
          })
        }
      })
      state.services.messages.on('pdf_error', event => {
        if (event.user === state.auth.user._id) {
          commit('setPdfMessage', {
            _id: event._id,
            message: {
              label: `PDF-ul ${event.count} nu a putut fi salvat...`,
              type: 'error'
            }
          })
        }
      })
      state.services.messages.on('pdf_count', event => {
        if (event.user === state.auth.user._id) {
          commit('setPdfMessage', {
            _id: event._id,
            message: {
              label: `Se salveaza ${event.count} pdf-uri`,
              type: 'info'
            }
          })
        }
      })
      state.services.messages.on('pdf_now', event => {
        if (event.user === state.auth.user._id) {
          commit('setPdfMessage', {
            _id: event._id,
            message: {
              label: `Se salveaza pdf-ul ${event.count}!`,
              type: 'info'
            }
          })
        }
      })
    },

    fetchUsers ({commit, state}) {
      commit('setFetching', true)
      let query = {
        $skip: (state.admin.users.page - 1) * 10,
        $sort: state.admin.users.sort
      }
      if (state.admin.users.search.length) {
        query['orRegex'] = [
          {
            username: {
              $search: state.admin.users.search
            }
          },
          {
            email: {
              $search: state.admin.users.search
            }
          }
        ]
      }
      state.services.users.find({query}).then(result => {
        commit('fillUsers', result)
        commit('setFetching', false)
      })
    },
    saveUser ({dispatch, commit, state}, data) {
      state.services.users.create(data)
        .then(res => {
          dispatch('fetchUsers')
          commit('setSnack', {
            error: {
              message: 'Operatiune reusita. Utilizator adaugat.'
            },
            meta: {
              error: false,
              success: true,
              info: false,
              warning: false
            }
          })
        })
        .catch(error => {
          let meta = { error: true, success: false, info: false, warning: false }
          commit('setSnack', { error, meta })
        })
    },
    updateUser ({dispatch, commit, state}, data) {
      state.services.users.patch(data._id, data)
        .then(res => {
          dispatch('fetchUsers')
          commit('setSnack', {
            error: {
              message: 'Operatiune reusita. Utilizator modificat.'
            },
            meta: {
              error: false,
              success: true,
              info: false,
              warning: false
            }
          })
        })
        .catch(error => {
          let meta = { error: true, success: false, info: false, warning: false }
          commit('setSnack', { error, meta })
        })
    },
    deleteUser ({dispatch, commit, state}, _ids) {
      state.services.users.remove(null, {query: {_id: {$in: _ids}}})
        .then(res => {
          dispatch('fetchUsers')
          commit('setSnack', {
            error: {
              message: `Operatiune reusita. ${res.length} utilizator(i) eliminat(i).`
            },
            meta: {
              error: false,
              success: true,
              info: false,
              warning: false
            }
          })
        })
        .catch(error => {
          let meta = { error: true, success: false, info: false, warning: false }
          commit('setSnack', { error, meta })
        })
    },
    setUsersPage ({commit, dispatch}, page) {
      commit('setUsersPage', page)
      dispatch('fetchUsers')
    },
    setUsersSort ({commit, dispatch}, sort) {
      commit('setUsersSort', sort)
      dispatch('fetchUsers')
    },
    setUsersSearch ({commit, dispatch}, search) {
      commit('setUsersSearch', search)
      dispatch('fetchUsers')
    },

    fetchMyAddresses ({commit, state}) {
      commit('setFetching', true)
      let query = {
        $skip: (state.addresses.mine.page - 1) * 10,
        $sort: state.addresses.mine.sort,
        $populate: [{
          path: 'photos',
          options: {
            sort: {
              'createdAt': -1
            }
          }
        },
        {
          path: 'pdfs',
          options: {
            sort: {
              'createdAt': -1
            }
          }
        },
        {
          path: 'users',
          options: {
            sort: {
              'username': 1
            }
          }
        }],
        users: {
          $in: [state.auth.user._id]
        }
      }

      if (state.addresses.mine.google === -1) {
        query['google'] = {
          $exists: true
        }
        query['offset'] = {
          $eq: true
        }
      } else if (state.addresses.mine.google === 1) {
        query['google'] = {
          $exists: true
        }
        query['offset'] = {
          $eq: false
        }
      } else if (state.addresses.mine.google === 2) {
        query['google'] = {
          $exists: false
        }
      }

      if (state.addresses.mine.images === 1) {
        query['photos.0'] = {
          $exists: true
        }
      } else if (state.addresses.mine.images === -1) {
        query['photos.0'] = {
          $exists: false
        }
      }

      if (state.addresses.mine.done === 1) {
        query['done'] = {
          $in: [true, 'true']
        }
      } else if (state.addresses.mine.done === -1) {
        query['done'] = {
          $in: [false, 'false']
        }
      }

      if (state.addresses.mine.search.length) {
        query['orRegex'] = [
          {
            address: {
              $search: state.addresses.mine.search
            }
          },
          {
            nrcrt: {
              $search: state.addresses.mine.search
            }
          },
          {
            title: {
              $search: state.addresses.mine.search
            }
          }
        ]
      }
      state.services.addresses.find({query}).then(result => {
        commit('fillMyAddresses', result)
        commit('setFetching', false)
      })
    },

    refreshAddress ({commit, state}, {id, type}) {
      commit('setFetching', true)
      let query = {
        _id: id,
        $populate: [{
          path: 'photos',
          options: {
            sort: {
              'createdAt': -1
            }
          }
        },
        {
          path: 'pdfs',
          options: {
            sort: {
              'createdAt': -1
            }
          }
        },
        {
          path: 'users',
          options: {
            sort: {
              'username': 1
            }
          }
        }],
        users: {
          $in: [state.auth.user._id]
        }
      }
      state.services.addresses.find({query}).then(result => {
        if (result.data[0]) {
          commit('refreshAddress', {item: result.data[0], type})
          commit('setFetching', false)
        }
      })
    },

    darnicie ({state, commit}, payload) {
      state.services.addresses.patch(null, {
        $push: {
          users: {
            $each: payload
          }
        }
      }).then(res => {
        commit('setSnack', {
          error: {
            message: 'Operatiune efectuata cu succes!'
          },
          meta: {
            error: false,
            success: false,
            info: true,
            warning: false
          }
        })
      }).catch(err => {
        console.log(err)
        commit('setSnack', {
          error: {
            message: 'A aparut o eroare la procesarea cererii...'
          },
          meta: {
            error: true,
            success: false,
            info: false,
            warning: false
          }
        })
      })
    },
    calicie ({state, commit}, payload) {
      state.services.addresses.patch(null, {
        $pull: {
          users: {
            $in: payload
          }
        }
      }).then(res => {
        commit('setSnack', {
          error: {
            message: 'Operatiune efectuata cu succes!'
          },
          meta: {
            error: false,
            success: false,
            info: true,
            warning: false
          }
        })
      }).catch(err => {
        console.log(err)
        commit('setSnack', {
          error: {
            message: 'A aparut o eroare la procesarea cererii...'
          },
          meta: {
            error: true,
            success: false,
            info: false,
            warning: false
          }
        })
      })
    },

    saveMyAddress ({dispatch, commit, state}, data) {
      commit('addressLoading', true)
      state.services.addresses.create(data)
        .then(res => {
          commit('addressLoading', false)
          commit('setSnack', {
            error: {
              message: 'Operatiune reusita. Adresa adaugata.'
            },
            meta: {
              error: false,
              success: true,
              info: false,
              warning: false
            }
          })
        })
        .catch(error => {
          commit('addressLoading', false)
          let meta = { error: true, success: false, info: false, warning: false }
          commit('setSnack', { error, meta })
        })
    },
    updateMyAddress ({dispatch, commit, state}, data) {
      commit('addressLoading', true)
      state.services.addresses.patch(data._id, data)
        .then(res => {
          // dispatch('fetchMyAddresses')
          commit('addressLoading', false)
          commit('setSnack', {
            error: {
              message: 'Operatiune reusita. Adresa modificata.'
            },
            meta: {
              error: false,
              success: true,
              info: false,
              warning: false
            }
          })
        })
        .catch(error => {
          commit('addressLoading', false)
          let meta = { error: true, success: false, info: false, warning: false }
          commit('setSnack', { error, meta })
        })
    },
    deleteMyAddress ({dispatch, commit, state}, _ids) {
      if (typeof _ids === 'string') {
        state.services.addresses.remove(_ids)
          .then(res => {
            // dispatch('fetchMyAddresses')
            commit('setSnack', {
              error: {
                message: `Operatiune reusita. Adresa eliminata.`
              },
              meta: {
                error: false,
                success: true,
                info: false,
                warning: false
              }
            })
          })
          .catch(error => {
            let meta = { error: true, success: false, info: false, warning: false }
            commit('setSnack', { error, meta })
          })
      } else {
        state.services.addresses.remove(null, {query: {_id: {$in: _ids}}})
          .then(res => {
            dispatch('fetchMyAddresses')
            commit('setSnack', {
              error: {
                message: `Operatiune reusita. ${res.length} adresa(e) eliminata(e).`
              },
              meta: {
                error: false,
                success: true,
                info: false,
                warning: false
              }
            })
          })
          .catch(error => {
            let meta = { error: true, success: false, info: false, warning: false }
            commit('setSnack', { error, meta })
          })
      }
    },
    setMyAddressesPage ({commit, dispatch}, page) {
      commit('setMyAddressesPage', page)
      dispatch('fetchMyAddresses')
    },
    setMyAddressesSort ({commit, dispatch}, sort) {
      commit('setMyAddressesSort', sort)
      dispatch('fetchMyAddresses')
    },
    setMyAddressesSearch ({commit, dispatch}, search) {
      commit('setMyAddressesSearch', search)
      dispatch('fetchMyAddresses')
    },

    setAddressDone ({state, commit}, payload) {
      commit('addressLoading', true)
      state.services.addresses.patch(payload.id, {done: payload.value})
        .then(res => {
          // dispatch('fetchMyAddresses')
          commit('addressLoading', false)
          commit('setSnack', {
            error: {
              message: 'Operatiune reusita. Adresa modificata.'
            },
            meta: {
              error: false,
              success: true,
              info: false,
              warning: false
            }
          })
        })
        .catch(error => {
          commit('addressLoading', false)
          let meta = { error: true, success: false, info: false, warning: false }
          commit('setSnack', { error, meta })
        })
    },

    toggleAddressesAccess ({commit, dispatch}, access) {
      commit('toggleAddressesAccess', access)
      dispatch('fetchAddresses')
    },
    toggleAddressesDone ({commit, dispatch}, done) {
      commit('toggleAddressesDone', done)
      dispatch('fetchAddresses')
    },
    toggleAddressesGoogle ({commit, dispatch}, google) {
      commit('toggleAddressesGoogle', google)
      dispatch('fetchAddresses')
    },
    toggleAddressesImages ({commit, dispatch}, images) {
      commit('toggleAddressesImages', images)
      dispatch('fetchAddresses')
    },

    toggleMyAddressesDone ({commit, dispatch}, done) {
      commit('toggleMyAddressesDone', done)
      dispatch('fetchMyAddresses')
    },
    toggleMyAddressesGoogle ({commit, dispatch}, google) {
      commit('toggleMyAddressesGoogle', google)
      dispatch('fetchMyAddresses')
    },
    toggleMyAddressesImages ({commit, dispatch}, images) {
      commit('toggleMyAddressesImages', images)
      dispatch('fetchMyAddresses')
    },

    fetchAddresses ({commit, state}) {
      /* eslint-disable no-dupe-keys */
      commit('setFetching', true)
      let query = {
        $skip: (state.addresses.all.page - 1) * 10,
        $sort: state.addresses.all.sort,
        $populate: [{
          path: 'photos',
          options: {
            sort: {
              'createdAt': -1
            }
          }
        },
        {
          path: 'pdfs',
          options: {
            sort: {
              'createdAt': -1
            }
          }
        },
        {
          path: 'users',
          options: {
            sort: {
              'username': 1
            }
          }
        }]
      }

      if (state.addresses.all.google === -1) {
        query['google'] = {
          $exists: true
        }
        query['offset'] = {
          $eq: true
        }
      } else if (state.addresses.all.google === 1) {
        query['google'] = {
          $exists: true
        }
        query['offset'] = {
          $eq: false
        }
      } else if (state.addresses.all.google === 2) {
        query['google'] = {
          $exists: false
        }
      }

      if (state.addresses.all.images === 1) {
        query['photos.0'] = {
          $exists: true
        }
      } else if (state.addresses.all.images === -1) {
        query['photos.0'] = {
          $exists: false
        }
      }

      if (state.addresses.all.done === 1) {
        query['done'] = {
          $in: [true, 'true']
        }
      } else if (state.addresses.all.done === -1) {
        query['done'] = {
          $in: [false, 'false']
        }
      }

      if (state.addresses.all.access === 1) {
        query['users.0'] = {
          $exists: true
        }
      } else if (state.addresses.all.access === -1) {
        query['users.0'] = {
          $exists: false
        }
      }

      if (state.addresses.all.search.length) {
        query['orRegex'] = [
          {
            address: {
              $search: state.addresses.all.search
            }
          },
          {
            nrcrt: {
              $search: state.addresses.all.search
            }
          },
          {
            title: {
              $search: state.addresses.all.search
            }
          }
        ]
      }
      state.services.addresses.find({query}).then(result => {
        commit('fillAddresses', result)
        commit('setFetching', false)
      })
    },
    saveAddress ({dispatch, commit, state}, data) {
      state.services.addresses.create(data)
        .then(res => {
          // dispatch('fetchMyAddresses')
          commit('setSnack', {
            error: {
              message: 'Operatiune reusita. Adresa adaugata.'
            },
            meta: {
              error: false,
              success: true,
              info: false,
              warning: false
            }
          })
        })
        .catch(error => {
          let meta = { error: true, success: false, info: false, warning: false }
          commit('setSnack', { error, meta })
        })
    },
    updateAddress ({dispatch, commit, state}, data) {
      state.services.addresses.patch(data._id, data)
        .then(res => {
          // dispatch('fetchMyAddresses')
          commit('setSnack', {
            error: {
              message: 'Operatiune reusita. Adresa modificata.'
            },
            meta: {
              error: false,
              success: true,
              info: false,
              warning: false
            }
          })
        })
        .catch(error => {
          let meta = { error: true, success: false, info: false, warning: false }
          commit('setSnack', { error, meta })
        })
    },
    deleteAddress ({state, commit}, ids) {
      state.services.addresses.remove(null, {
        query: {
          _id: {
            $in: ids
          }
        }
      }).catch(error => {
        let meta = { error: true, success: false, info: false, warning: false }
        commit('setSnack', { error, meta })
      })
    },
    setAddressesPage ({commit, dispatch}, page) {
      commit('setAddressesPage', page)
      dispatch('fetchAddresses')
    },
    setAddressesSort ({commit, dispatch}, sort) {
      commit('setAddressesSort', sort)
      dispatch('fetchAddresses')
    },
    setAddressesSearch ({commit, dispatch}, search) {
      commit('setAddressesSearch', search)
      dispatch('fetchAddresses')
    },

    requestAccess ({state, commit}, id) {
      state.services.requests.create({
        address: id,
        user: state.auth.user._id
      }).then(result => {
        commit('setSnack', {
          error: {
            message: 'Cererea a fost inregistrata. Adresa va fi afisata in lista d-voastra de adrese in momentul in care veti primi access.'
          },
          meta: {
            error: false,
            success: false,
            info: true,
            warning: false
          }
        })
      }).catch(error => {
        let meta = { error: true, success: false, info: false, warning: false }
        commit('setSnack', { error, meta })
      })
    },

    fetchRequests ({commit, state}) {
      /* eslint-disable no-dupe-keys */
      commit('setFetching', true)
      let query = {
        $skip: (state.admin.requests.page - 1) * 10,
        $sort: state.admin.requests.sort,
        $populate: [{
          path: 'address',
          options: {
            sort: {
              'createdAt': -1
            }
          }
        },
        {
          path: 'user',
          options: {
            sort: {
              'username': 1
            }
          }
        }]
      }
      state.services.requests.find({query}).then(result => {
        commit('fillRequests', result)
        commit('setFetching', false)
      })
    },
    denyRequests ({state, commit}, ids) {
      state.services.requests.remove(null, {
        query: {
          _id: {
            $in: ids
          }
        }
      }).catch(error => {
        let meta = { error: true, success: false, info: false, warning: false }
        commit('setSnack', { error, meta })
      })
    },
    approveRequests ({state, commit}, ids) {
      state.services.requests.find({query: {_id: {$in: ids}}}).then(requests => {
        requests.data.forEach(request => {
          state.services.addresses.patch(request.address, {
            $push: {
              users: request.user
            }
          }).then(res => {
            state.services.requests.remove(null, {
              query: {
                _id: {
                  $in: [request._id]
                }
              }
            })
          }).catch(error => {
            let meta = { error: true, success: false, info: false, warning: false }
            commit('setSnack', { error, meta })
          })
        })
      }).catch(error => {
        let meta = { error: true, success: false, info: false, warning: false }
        commit('setSnack', { error, meta })
      })
    },
    setRequestsPage ({commit, dispatch}, page) {
      commit('setRequestsPage', page)
      dispatch('fetchRequests')
    },
    setRequestsSort ({commit, dispatch}, sort) {
      commit('setRequestsSort', sort)
      dispatch('fetchRequests')
    },

    savePhoto ({ state, dispatch, commit }, photo) {
      photo.forEach((p, i) => {
        if (i === 0) {
          state.services.photos.create(p)
            .catch(error => {
              let meta = { error: true, success: false, info: false, warning: false }
              commit('setSnack', { error, meta })
            })
        } else {
          setTimeout(() => {
            state.services.photos.create(p)
              .catch(error => {
                let meta = { error: true, success: false, info: false, warning: false }
                commit('setSnack', { error, meta })
              })
          }, i * 1000)
        }
      })
    },
    deletePhoto ({ state, commit }, photoID) {
      state.services.photos.remove(photoID)
        .catch(error => {
          let meta = { error: true, success: false, info: false, warning: false }
          commit('setSnack', { error, meta })
        })
    },
    savePdf ({ state, dispatch, commit }, pdf) {
      pdf.forEach((p, i) => {
        if (i === 0) {
          state.services.pdfs.create(p)
            .catch(error => {
              let meta = { error: true, success: false, info: false, warning: false }
              commit('setSnack', { error, meta })
            })
        } else {
          setTimeout(() => {
            state.services.pdfs.create(p)
              .catch(error => {
                let meta = { error: true, success: false, info: false, warning: false }
                commit('setSnack', { error, meta })
              })
          }, i * 1000)
        }
      })
    },
    deletePdf ({ state, commit }, pdfID) {
      state.services.pdfs.remove(pdfID)
        .catch(error => {
          let meta = { error: true, success: false, info: false, warning: false }
          commit('setSnack', { error, meta })
        })
    },

    removeUserFromAddress ({ state, commit }, ids) {
      state.services.addresses.patch(ids.address, {
        $pull: {
          users: ids.user
        }
      }).catch(error => {
        let meta = { error: true, success: false, info: false, warning: false }
        commit('setSnack', { error, meta })
      })
    },

    sendLocationInfo ({ state }, position) {
      let {coords: {latitude: lat, longitude: lng, accuracy}} = position
      state.services.users.patch(state.auth.user._id, {
        location: {
          coords: {
            lat, lng, accuracy
          },
          timestamp: new Date()
        }
      }).then(user => {
        if (accuracy < 100) {
          state.services.histories.create({
            user: user._id,
            coords: {
              lat, lng, accuracy
            },
            timestamp: new Date()
          })
        }
      })
    },

    getUserHistory ({ state }, id) {
      // get user history
      return state.services.histories.find({
        query: {
          user: id,
          paginate: false,
          $sort: {
            timestamp: 1
          }
        }
      })
    },

    fetchUsers4Map ({commit, state}) {
      commit('setFetching', true)
      let query = {
        paginate: false
      }

      state.services.users.find({query}).then(result => {
        commit('fillUsers4Map', result)
        commit('setFetching', false)
      })
    },
    fetchAddresses4Map ({commit, state}) {
      commit('setFetching', true)
      let query = {
        paginate: false,
        $populate: [{
          path: 'photos',
          options: {
            sort: {
              'createdAt': -1
            }
          }
        },
        {
          path: 'pdfs',
          options: {
            sort: {
              'createdAt': -1
            }
          }
        },
        {
          path: 'users',
          options: {
            sort: {
              'username': 1
            }
          }
        }]
      }

      state.services.addresses.find({query}).then(result => {
        commit('fillAddresses4Map', result)
        commit('setFetching', false)
      })
    },
    fetchMyAddresses4Map ({commit, state}) {
      commit('setFetching', true)
      let query = {
        paginate: false,
        $populate: [{
          path: 'photos',
          options: {
            sort: {
              'createdAt': -1
            }
          }
        },
        {
          path: 'pdfs',
          options: {
            sort: {
              'createdAt': -1
            }
          }
        },
        {
          path: 'users',
          options: {
            sort: {
              'username': 1
            }
          }
        }],
        users: {
          $in: [state.auth.user._id]
        }
      }

      state.services.addresses.find({query}).then(result => {
        commit('fillMyAddresses4Map', result)
        commit('setFetching', false)
      })
    },

    triggerArchive ({ state, commit }, {start, end}) {
      return state.services.archives.create({start, end})
    },
    fetchArchives ({ state, commit }) {
      commit('setFetching', true)
      let query = {
        $skip: (state.archives.page - 1) * 10,
        $sort: state.archives.sort
      }

      state.services.archives.find({query}).then(result => {
        commit('fillArchives', result)
        commit('setFetching', false)
      })
    },
    deleteArchive ({state, commit}, ids) {
      state.services.archives.remove(null, {
        query: {
          _id: {
            $in: ids
          }
        }
      }).catch(error => {
        let meta = { error: true, success: false, info: false, warning: false }
        commit('setSnack', { error, meta })
      })
    },
    setArchivesSort ({commit, dispatch}, sort) {
      commit('setArchivesSort', sort)
      dispatch('fetchArchives')
    },
    setArchivesPage ({commit, dispatch}, page) {
      commit('setArchivesPage', page)
      dispatch('fetchArchives')
    },

    uploadXLSX ({ state }, file) {
      return state.services.xlsx.create(file)
    }
  }
})

function grabAuthData (response, commit, dispatch) {
  return feathers.passport.verifyJWT(response.accessToken)
    .then(result => feathers.service('users').get(result.userId))
    .then(data => {
      commit('setAuth', {token: response.accessToken, user: data})
      commit('setSnack', {
        error: {
          message: 'Autentificare reusita. Sesiune de lucru pornita.'
        },
        meta: {
          error: false,
          success: true,
          info: false,
          warning: false
        }
      })
      dispatch('setEventWatchers')
      let lastPoint = null
      let km = null
      if (navigator.geolocation) {
        let geoWatch = setInterval(getLocation, 60000)
        commit('setPosInterval', geoWatch)
        getLocation()
      }

      function getLocation () {
        navigator.geolocation.getCurrentPosition((position) => {
          if (lastPoint === null) {
            lastPoint = [
              position.coords.latitude,
              position.coords.longitude
            ]
            dispatch('sendLocationInfo', position)
          } else {
            let currentPoint = [
              position.coords.latitude,
              position.coords.longitude
            ]
            km = distance(lastPoint, currentPoint)
          }
          // alert(`Debug1 - ${position.coords.accuracy}m lat:${position.coords.latitude} lng:${position.coords.longitude} km:${km}`)

          if (!km || km > 0.1) {
            dispatch('sendLocationInfo', position)
          }
          commit('setGeolocationPosition', position)
        }, (err) => {
          if (err.code === 1) {
            alert('Pentru ca aplicatia sa functioneze in conditii optime, va rugam sa permiteti accesul la pozitia d-voastra geografica!')
          } else if (err.code === 2) {
            alert('Sistemul d-voastra a raportat o eroare la incercarea de a gasi coordonatele d-voastra.')
            // clearInterval(geoWatch)
          } else {
            // alert('eroare la geolocation')
          }
        }, {
          enableHighAccuracy: false,
          timeout: 5000,
          maximumAge: 10000
        })
      }
    })
    .catch(error => {
      let meta = { error: true, success: false, info: false, warning: false }
      commit('setSnack', { error, meta })
      commit('setLoading', false)
    })
}



// WEBPACK FOOTER //
// ./src/store/index.js